/**
 * @deprecated This file is deprecated and will be removed in a future version.
 *
 * All theme values have been migrated to CSS variables in src/global/styles/global.css.
 * For new components, please use Tailwind CSS classes and CSS variables instead.
 *
 * Migration guide:
 * - Colors: Use Tailwind classes like `bg-main-blue`, `text-primary`, etc., or CSS variables like `var(--color-main-blue)`
 * - Typography: Use Tailwind text classes like `text-h1`, `text-body1`, `font-sans`, etc.
 * - All original colors are available with the `color-` prefix (e.g., `--color-main-blue`, `--color-gray-pale`)
 *
 * See tailwind.config.ts and global.css for the complete list of available CSS variables and Tailwind classes.
 */

const currentRoute = window.location.pathname;

const theme = {
  colors: {
    black: "#000000",
    mainBlue: "#0047E6",
    darkBlue: "#031F2A",
    lightBlue: "#AFEBF2",
    red: "#D71515",
    yellowShell: "#FBCC07",
    white: "#FFFFFF",
    greenLight: "#0C2856",
    greenDark: "#0C2856",
    grayLight: "#61656D",
    grayLighter: "#9EA0A4",
    grayPale: "#D9D9D9",
    backgroundPrimary: currentRoute.includes("app/alt-data")
      ? "#292C31"
      : "#EDEDF4",
    backgroundSecondary: currentRoute.includes("app/alt-data")
      ? "#3B3F48"
      : "#F9F9FF",
    backgroundTertiary: "#F8FDFF",
  },
  typography: {
    weight: {
      regular: 500,
      bold: 600,
    },
    size: {
      header: "2rem",
      title: "1.8rem",
      text: "1.2rem",
    },
    fontFamily: "Work Sans",
  },
};

export default theme;
